<input #fileInput type="file" accept="image/png, image/jpeg" hidden (change)="onImageSelected($event)" />
